import { useMemo, useState } from 'react';
import PublicDataTable from '../components/PublicDataTable';
import PublicFilterDropdown from '../components/PublicFilterDropdown';
import { CheckboxFilter } from '../components/FilterPanel';
import ContactCell from '../components/ContactCell';
import StatusBadge from '../components/Facilities/OperationalStatusBadge';
import { DirectoryHeader, DirectoryPage, FilterBy, LastUpdated } from '../components/Directory';
import {
  PRODUCTION_FACILITIES,
  PRODUCTION_FACILITY_TYPES,
  PRODUCTION_LAST_UPDATED,
  PRODUCTION_STATES,
} from '../data/livestockProductionData';

// Column order and labels from Figma 1293:52991
const COLUMNS = [
  { key: 'name',      title: 'Facility Name' },
  { key: 'contact',   title: 'Contact', render: (v) => <ContactCell number={v} /> },
  { key: 'type',      title: 'Facility Type' },
  { key: 'ownership', title: 'Ownership' },
  { key: 'species',   title: 'Source Species' },
  { key: 'products',  title: 'Products Processed' },
  {
    key: 'capacity',
    title: 'Capacity',
    render: (v) => (v != null ? Number(v).toLocaleString('en-NG') : '—'),
  },
  { key: 'unit',      title: 'Unit' },
  { key: 'status',    title: 'Operational Status', render: (v) => <StatusBadge status={v || '—'} /> },
];

export default function LivestockProduction() {
  const [query, setQuery] = useState('');
  const [state, setState] = useState(PRODUCTION_STATES[0]);
  const [facilityTypes, setFacilityTypes] = useState([]);

  const rows = useMemo(() => PRODUCTION_FACILITIES.filter((row) =>
    (state === 'All States' || row.state === state) &&
    (!facilityTypes.length || facilityTypes.includes(row.type))
  ), [state, facilityTypes]);

  return (
    <DirectoryPage>
      <DirectoryHeader
        eyebrow="Livestock Production Directory"
        subject="Livestock Production facilities"
        query={query}
        onQueryChange={setQuery}
      />

      <FilterBy>
        <PublicFilterDropdown
          value={state}
          options={PRODUCTION_STATES}
          onChange={setState}
          ariaLabel="Filter by state"
        />
        <CheckboxFilter
          label="All Facility Type"
          title="Facility Type"
          options={PRODUCTION_FACILITY_TYPES}
          selected={facilityTypes}
          onChange={setFacilityTypes}
        />
      </FilterBy>

      <PublicDataTable columns={COLUMNS} data={rows} searchQuery={query} pageSize={10} />

      <LastUpdated date={PRODUCTION_LAST_UPDATED} />
    </DirectoryPage>
  );
}
